import { skipToken } from "@reduxjs/toolkit/query";
import type {
  PlaybookCriterionId,
  PlaybookId,
} from "@repo/app-types/entities/playbook";
import type { TeammateId } from "@repo/app-types/entities/teammate";
import { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";
import { GradingReferenceProvider } from "@repo/ui/structuredContent/gradingReferenceContext";
import { renderStructuredContent } from "@repo/ui/structuredContent/structuredContentRenderer";
import type { FC } from "react";
import { Heading } from "react-aria-components";
import { usePlaybookTeammateCriterionTakeawayQuery } from "../../api/entities/performancePlaybook.js";
import { useIsFeatureFlagEnabled } from "../../helpers/featureFlags/hooks.js";
import { GradingReferenceLinkAdapter } from "./gradingReferenceLinkAdapter.js";

interface CriterionTakeawayProps {
  playbookId: PlaybookId;
  teammateId: TeammateId;
  criterionId: PlaybookCriterionId;
}

export const CriterionTakeaway: FC<CriterionTakeawayProps> = (props) => {
  const { playbookId, teammateId, criterionId } = props;
  const isEnabled = useIsFeatureFlagEnabled(
    FeatureFlagKey.TeammateCoachingTakeaways,
  );
  const { currentData: takeaway } = usePlaybookTeammateCriterionTakeawayQuery(
    isEnabled ? { playbookId, teammateId, criterionId } : skipToken,
  );
  if (!takeaway) {
    return null;
  }

  return (
    <section className="flex flex-col gap-3">
      <Heading level={2} className="text-base font-semibold text-foreground">
        Takeaway
      </Heading>
      <GradingReferenceProvider value={GradingReferenceLinkAdapter}>
        <div className="text-sm text-foreground">
          {renderStructuredContent(takeaway.takeaway_note, {
            playbookId,
            teammateId,
            criterionId,
          })}
        </div>
      </GradingReferenceProvider>
    </section>
  );
};
